import { useCallback, useMemo } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { CustomSelectWithSearchBar } from '../../../../../forms/CustomSelect'
import { dictionaryComplexFromJsonArr } from '../../../../../utils/globals/dictionary'
import useEditDeleteModal from '../../../../../utils/hooks/useEditDeleteModal'
import { AllReduxAppPayloads, GlobalContext } from '../../../../../utils/reducers'
import { changeCurrentWorkingCenter } from '../../../../../utils/reducers/reduxDispatch'
import ModalConfirmChangeWorkingCenter from './ModalConfirmChangeWorkingCenter'
import './chooseworking.sass'

interface ChooseWorkingCenterProps extends ChooseWorkingCenterLogicProps {
    label?: string
    secondLabel?: string
}

const ChooseWorkingCenter: React.FC<ChooseWorkingCenterProps> = ({ WorkingCenterId, WorkingCenterStationId, label, secondLabel,  ...rest}) => {
    const { workingCentersMemorized, workingCenterStationsMemorized, handleChangeWorkingCenter, openModal, setOpenModal, handleSelectedWorkingCenter } = useChooseWorkingCenterLogic({ WorkingCenterId, WorkingCenterStationId, ...rest })
    if (!Object.keys(workingCentersMemorized).length) {
        return null
    }
    return (
        <div className='flex'>
            <CustomSelectWithSearchBar items={workingCentersMemorized} label={label || ''} value={WorkingCenterId} className={'for_header w-full'} onChange={(value) => handleChangeWorkingCenter(value, undefined)} sortItems={true} isStateLess={true} />
            {workingCenterStationsMemorized ? <CustomSelectWithSearchBar items={workingCenterStationsMemorized} label={secondLabel || ''} className={'for_header'} onChange={(value) => handleChangeWorkingCenter(undefined, value)} sortItems={true} value={WorkingCenterStationId} /> : null}
            {openModal?.type === 'edit' ? <ModalConfirmChangeWorkingCenter handleSelectedWorkingCenter={handleSelectedWorkingCenter} setOpened={() => setOpenModal(null)} allRowData={openModal?.allRowData} onSubmit={() => {}} />: null}
        </div>
    )

}

interface ChooseWorkingCenterLogicProps extends ReduxChooseWorkingCenterConnector {}

const useChooseWorkingCenterLogic = ({ workingCenters, WorkingCenterId }: ChooseWorkingCenterLogicProps) => {
    const workingCentersMemorized = useMemo(() => dictionaryComplexFromJsonArr(workingCenters || {}), [workingCenters])
    const workingCenterStationsMemorized = useMemo(() => (WorkingCenterId && workingCenters?.[WorkingCenterId]?.WorkingCenterStations?.length) ? dictionaryComplexFromJsonArr(workingCenters?.[WorkingCenterId]?.WorkingCenterStations || []) : null, [workingCenters, WorkingCenterId])
    const { openModal, setOpenModal } = useEditDeleteModal()

    const handleChangeWorkingCenter = useCallback((SelectedWorkingCenterId?: number, SelectedWorkingCenterStationId?: number) => {
        setOpenModal({ type: 'edit', allRowData: { WorkingCenterId: SelectedWorkingCenterId || WorkingCenterId, WorkingCenterStationId: SelectedWorkingCenterStationId }})
    }, [setOpenModal, WorkingCenterId])

    const handleSelectedWorkingCenter = useCallback((WorkingCenterId?: number, WorkingCenterStationId?: number) => {
        changeCurrentWorkingCenter(WorkingCenterId, WorkingCenterStationId)
    }, [])
    return { workingCentersMemorized, workingCenterStationsMemorized, handleSelectedWorkingCenter, handleChangeWorkingCenter, openModal, setOpenModal }
}

const mapChooseWorkingCenterConnector = (state: AllReduxAppPayloads) => ({ workingCenters: state.user?.extraData.WorkingCenters, WorkingCenterId: state.user?.extraData.WorkingCenterId, WorkingCenterStationId: state.user?.extraData.WorkingCenterStationId })
export const chooseWorkingCenterConnector = connect(mapChooseWorkingCenterConnector, null, null, { context: GlobalContext })
export type ReduxChooseWorkingCenterConnector = ConnectedProps<typeof chooseWorkingCenterConnector>


const ChooseWorkingCenterConnector = chooseWorkingCenterConnector(ChooseWorkingCenter)

export default ChooseWorkingCenterConnector